const generateData = (rows) => {
  const newData = rows.map((row, key) => ({
    totalTransaction: row.cols[0], // تعداد کل تراکنش
    sumDeposit: row.cols[1], // مجموع واریز
    sumWithdrawal: row.cols[2], //  مجموع برداشت
    creditBalance: row.cols[3], // مانده اعتبار مصرف نشده
    remaining: row.cols[4], // مانده 
    totalBalanceDeposite: row.cols[5], // مجموع قابل مصرف (نقد و اعتبار)
    totalBalance: row.cols[6], // مبلغ کل اعتبار تخصیص شده
  }));

  return newData;
};

export default generateData;
